<div class="table-filter-panel">
  @if (showSearchBar()) {
    <div class="table-filter-header search">
      <div class="table-filter-search-input">
        <input
          #searchInput
          type="text"
          [value]="searchText ?? ''"
          (input)="onSearchInput($any($event.target).value)"
          (keydown)="onInputKeyDown($event)"
        />
        @if (!searchText) {
          <i class="material-icons search-icon">search</i>
        } @else {
          <button class="btn-search-cancel" (click)="cancelSearch()"><i class="material-icons">clear</i></button>
        }
      </div>
    </div>
  }
  <div class="table-filter-content">
    <ng-content></ng-content>
  </div>
</div>
